import { Pagination } from '../interfaces/common';

/**
 * Purpose: Certain collections need to be pulled all at once because of search-and-match actions (easier to search/select)
 */
export const DEFAULT_HUGE_PAGE_SIZE = 2000;

export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_ROWS_PER_PAGE = [10, 20, 25, 30, 50, 100, 200, 300, 400];

export const DEFAULT_5_MINUTES_IN_MS = 5 * 60 * 1000;

export const INITIAL_PAGINATION_STATE: Pagination = {
  currentPage: 1,
  perPage: DEFAULT_PAGE_SIZE,
  totalPages: 1,
  totalCount: 1,
};

export const billingExport = {
  TITLE_PAGE: 'Billing Export',
  FLOW: 'File from drchrono => Billing => Live claims feed => Custom export',
  URL_DOCUMENTATION: 'https://bit.ly/mankato-billing-extract-documentation',
  TEXT_ABOVE_URL: 'click link above for documentation',
  NO_FILE_CHOSEN: 'No file chosen',
  LOADING: 'Loading...',
  NO_ACCESS: 'Sorry, you are not authorized to access this option.',
  FEATURE: 'Once the file is done processing it will also be sent to your email.',
  FILE_INPUT: 'Drop (or click to upload) the csv file of the billing export that will be processed',
  PROCESSING: 'Processing...',
};

export const labelButton = {
  FILTER: 'Filter',
  SEARCH: 'Search',
  CLOSE: 'Close',
  SHOW: 'Show',
  BACK: 'Back',
  SEND: 'Send',
  CLEAR: 'Clear',
};

export const labelPartner = {
  TITLE_DETAIL: 'Partner detail',
  TITLE_APPOINTMENT: 'Appointments',
  NOT_MAPPED: 'Not mapped',
};

export enum Roles {
  Billing = 'Billing',
  Operations = 'Operations',
  TechSupport = 'Tech Support',
}

export const StorageName = {
  AUTH: 'Authorization',
  // When the credential in AUTH stops working; set only for Hub-minted sessions
  AUTH_EXPIRES_AT: 'AuthorizationExpiresAt',
  // When this browser signed the session in, by its own clock; anchors the expiry ceiling
  AUTH_STARTED_AT: 'AuthorizationStartedAt',
  // 'hub' when the credential in AUTH was minted by the Hub, which must also end it
  AUTH_SOURCE: 'AuthorizationSource',
  ROLES: 'Roles',
  PROFILE: 'Profile',
};

export const AutoACEImporter = {
  FLOW: 'Copy and paste from Athena => Paste the cookie from Athena EHR => Paste the content copied from Athena EHR => Proceed',
  LOADING: 'Loading...',
  PROCESSING: 'Processing...',
};

export const MANKATO_CLINIC_SLUG = 'com.mankato.mn.main';
